import React from 'react';
import { useClipboard } from 'use-clipboard-copy';

export const useClipboardWithState = (): [any, (str) => void] => {
  const clipboard = useClipboard({
    copiedTimeout: 600 // timeout duration in milliseconds
  });
  const copyToClipboard = React.useCallback(
    str => {
      clipboard.copy(str); // programmatically copying a value
    },
    [clipboard]
  );

  return [clipboard, copyToClipboard];
};
